<template>
  <div v-if="event" class="event-item">
    <div class="text-center" v-if="event.image">
      <img :src="event.image" v-bind:alt="event.title" class="img-fluid" data-fancybox="gallery" />
    </div>
    <p class="mb-1 font-bold" v-if="event.company">{{ event.company }}</p>
    <h3 v-if="event.title">{{ event.title }}</h3>
    <h4 v-if="event.subtitle">{{ event.subtitle }}</h4>
    <p v-if="event.text" v-html="event.text"></p>
    <p v-for="(item, index) in event.items"
      :key="index">
      <strong><span v-if="item.title">{{ item.title }} at</span> 
        {{ item.time }}</strong>
    <br>
    <span class="font-bold" v-if="item.location">Location:</span> {{ item.location }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  name: 'EventsListItem',
  props: ['event']
}
</script>

<style>
</style>

<style scoped>
hr {
  background-color: #737a7e;
}
.text-info {
  color: #737a7e  !important;
}
</style>
